import type { ReactNode } from 'react'
import { ApiError } from '../api/public'

// The three states a load can be in, rendered.
//
// Split from `useApi` so this file exports only components: React Fast Refresh
// cannot reload a module that mixes components with anything else, which turns
// every edit here into a full page reload while building a view.

export function Loading({ what }: { what: string }) {
  return (
    <p className="state-loading" role="status">
      Loading {what}…
    </p>
  )
}

export function Failed({ what, error }: { what: string; error: Error }) {
  const requestId = error instanceof ApiError ? error.problem.request_id : undefined
  return (
    <div className="state-error" role="alert">
      <p>{what} could not be loaded.</p>
      <p className="state-error-detail">{error.message}</p>
      {requestId && <p className="state-error-id">Request {requestId}</p>}
    </div>
  )
}

/** Empty is a real answer, and says so rather than rendering nothing. */
export function Empty({ children }: { children: ReactNode }) {
  return <p className="state-empty">{children}</p>
}
